import Card from "components/card";
import React, { useEffect,  useState } from "react";
import InputField from "components/fields/InputField";
import { useNavigate } from "react-router-dom";
import { MdAddBox } from "react-icons/md";
import { ESService } from "services/esService";
import ApiList from "services/apiList";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import Loader from "components/loader";
import Pagination from "components/pagination";
const Lessons = () => {
  const user = useSelector(currentUser);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const columnsData = ["№", "Нэр", "Богино нэр", "Хичээлийн төрөл"];
  const [tableData, setTableData] = useState([]);

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const getData = () => {
          const token = user.token;
          const es = new ESService(token);
          es.get(
            ApiList.lessonUrl,
              "search=" +
              search +
              "&isPaginated=1&page=" +
              currentPage
          ).then((json) => {
            if (json["status"]) {
              setTotalPage(json["data"]["count"]);
              setTableData(json["data"]["result"]);
              setLoading(false);
            }
          });
        };

        await getData();
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [currentPage, search, user.token, user.school.id]);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <Card extra={"w-full h-full p-4  mt-4"}>
          <div>
            <div className="relative mb-4 flex items-center justify-between">
              <div className="items-end gap-3 lg:flex ">
                <InputField
                  key={"searchInput"}
                  value={search}
                  placeholder="Хичээлийн нэрээр хайх "
                  className="focus:shadow-outline w-full outline-none transition-all duration-700 ease-in-out lg:w-80 lg:focus:w-96 "
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
              </div>
              <button
                onClick={() => {
                  navigate("/admin/lesson_detail", {
                    state: { type: "register" },
                  });
                }}
                className={`flex items-center text-xl hover:cursor-pointer ${"bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"} linear justify-center rounded-lg font-bold transition duration-200`}
              >
                <MdAddBox className="h-6 w-6" />
              </button>
            </div>

            <div className="h-full overflow-x-scroll xl:overflow-hidden">
              <table className="responsive_table">
                <thead>
                  <tr key={"l-header"}>
                    {columnsData.map((column, index) => (
                      <th key={"user-header" + index}>{column}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, i) => {
                    return (
                      <tr key={i}>
                        <td data-label="№">{(currentPage - 1) * 30 + i + 1}</td>
                        <td data-label="Нэр">
                          <button
                            onClick={() => {
                              navigate("/admin/lesson_detail", {
                                state: { type: "edit", id: row.id },
                              });
                            }}
                            className="text-left text-blue-800 underline hover:text-blue-600 dark:text-white"
                          >
                            {row.name}
                          </button>
                        </td>
                        <td data-label="Богино нэр">{row.shortname}</td>
                        <td data-label="Хичээлийн төрөл">
                          {row.lesson_type != null ? row.lesson_type.name : "-"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <Pagination
              current={currentPage}
              total={totalPage}
              setCurrent={(index) => {
                setCurrentPage(index);
              }}
            />
          </div>
        </Card>
      )}
    </div>
  );
};

export default Lessons;
